import { setupWorker } from 'msw/browser'
import { handlers } from './handlers'

// Setup MSW worker for browser environment
export const worker = setupWorker(...handlers)

// Start worker with default configuration
export const startWorker = async () => {
    if (import.meta.env.DEV) {
        console.log('MSW: Starting Mock Service Worker...')
        await worker.start({
            onUnhandledRequest: 'warn',
            serviceWorker: {
                url: '/mockServiceWorker.js'
            }
        })
        console.log('MSW: Mock Service Worker started successfully')
        console.log('MSW: Registered handlers for:', [
            'POST */api/mobile/v1/residency/bind-request',
            'GET */api/mobile/v1/residency/bind-request/status'
        ])
    }
}